import React, { useState } from "react";
import AnimatedContent from "../common/AnimatedContent";
import PageTitle from "../common/PageTitle";
import MeetingTable from "../Components/meetingInfo/MeetingTable";
import { FaFilter } from "react-icons/fa";
import MeetingInfoData from "../utils/MeetingInfoData";
import { BsEye } from "react-icons/bs";
import { FaRegCalendarCheck } from "react-icons/fa6";
import { RiTimerLine } from "react-icons/ri";
import Drawer from "../common/Drawer";
import MeetingFilter from "../Components/meetingInfo/MeetingFilter";
import MeetingInfoTabs from "../Components/meetingInfo/MeetingInfoTabs";
import MeetingHistory from "../Components/meetingInfo/MeetingHistory";
import ListModel from "../common/ListModel";
import useMeeting from "../hooks/useMeeting";
import { RiHistoryLine } from "react-icons/ri";
import { TbReplace } from "react-icons/tb";
import CustomChip from "../common/CustomChip";
import { MdOutlineCancel } from "react-icons/md";
import SchedulerStatus from "../Enum/SchedulerStatus";
import { notifyError } from "../utils/toast";
import Loading from "../common/Loading";

const Dashboard = () => {
  const [visible, setVisible] = useState(false);
  const [visibleHistory, setVisibleHistory] = useState(false);
  const [meetingId, setMeetingId] = useState();
 
  const {
    data,
    limit,
    selectedMeeting,
    setSelectedMeeting,
    presonList,
    selectedId,
    setSelectedId,
    loading,
    handleReassign,
    setIsListModelOpen,
    isListModelOpen,
    meetingPersonData,
    currentPage,
    nextId,
    prevId,
    handlePageChange,
    handlePageSize,
    handleApplyFilters,
    handleClearFilters,
    removeFilter,
    modalOpen,
    setModalOpen,
    filters,
    handleReportDownload,
    loader,
    hasMore,
    statusCounts
  } = useMeeting();

  const columns = [

    {
      key: "title",
      title: "Meeting Title",
      render: (text, record) => (
        <div
          onClick={() => {
            setSelectedMeeting(record);
            setVisible(true);
          }}
          title={text.replace(/\b\w/g, (char) => char.toUpperCase())}
          className=" cursor-pointer line-clamp-2 text-center truncate"
        >
          {text.replace(/\b\w/g, (char) => char.toUpperCase())}
        </div>
      ),
    },
    {
      key: "contactPerson",
      title: "Meeting Person",
      render: (text, record) => (
        <div
          title={text.replace(/\b\w/g, (char) => char.toUpperCase())}
          className=" cursor-pointer text-center truncate"
        >
          {text.replace(/\b\w/g, (char) => char.toUpperCase())}
        </div>
      ),
    },

  
    {
      key: "meetingDate",
      title: "Date",
      render: (text) => (
        <div className="bg-green-50 mx-auto flex items-center justify-center gap-2 text-xs border border-green-500 rounded-full p-1 w-max text-center">
          <FaRegCalendarCheck className="text-primary" />
          <div>{text.replace(/\//g, "-")}</div>
        </div>
      ),
    },
    {
      key: "meetingDuration",
      title: "Time",
      render: (text) => (
        <div className="bg-violet-50 mx-auto flex items-center justify-center gap-2 text-xs border border-violet-500 rounded-full p-1 w-max text-center">
          <RiTimerLine className="text-violet-500" />
          <div>{text}</div>
        </div>
      ),
    },
    {
      key: "assignee",
      title: "Assignee",
      render: (text) => <div className="text-center">{text?.name}</div>,
    },
    {
      key: "meetingIncharge",
      title: "Meeting Incharge",
      width: "160px",
      render: (text) => (
        <div title={text || "-"} className="text-center line-clamp-3 break-words max-w-[160px] mx-auto overflow-hidden">{text || "-"}</div>
      ),
    },
    {
      key: "status",
      title: "Status",
      render: (text) => {
        const matchstatus = SchedulerStatus.find((list) => list.value === text);
    
        return (
          <div
            className={`text-xs px-3 py-1 border rounded-full w-max mx-auto font-semibold ${
              matchstatus?.value === "COMPLETED"
                ? "border-green-500 bg-green-50 text-green-700"
                : matchstatus?.value === "CANCELLED"
                ? "border-red-500 bg-red-50 text-red-700"
                : "bg-yellow-50 border-yellow-500 text-yellow-700"
            }`}
          >
            {matchstatus?.label}
          </div>
        );
      },
    },
    {
      key: "initialMeetingInformationMedium",
      title: "Initial Info Medium",
      width: "140px",
      render: (text) => (
        <div title={text || "-"} className="text-center line-clamp-3 break-words max-w-[140px] mx-auto overflow-hidden">{text || "-"}</div>
      ),
    },
    {
      key: "finalMeetingInformationMedium",
      title: "Final Info Medium",
      width: "140px",
      render: (text) => (
        <div title={text || "-"} className="text-center line-clamp-3 break-words max-w-[140px] mx-auto overflow-hidden">{text || "-"}</div>
      ),
    },
    {
      key: "Action",
      title: "Action",
      render: (_, record) => (
        <div className="flex justify-center items-center gap-4 text-blue-500 text-lg font-semibold">
          <BsEye
            className="cursor-pointer"
            onClick={() => {
              setSelectedMeeting(record);
              setVisible(true);
            }}
            aria-label="View meeting details"
          />
          <TbReplace
            className="cursor-pointer"
            onClick={() => {
              setIsListModelOpen(record);
              setSelectedMeeting(record);
              setSelectedId(record?.assignee?.id);
              console.log("Edit meeting:", record);
            }}
            aria-label="Edit meeting"
          />
          <RiHistoryLine
            className="cursor-pointer"
            onClick={() => {
              setVisibleHistory(record);
              setMeetingId(record.id);
              console.log("Edit meeting:", record);
            }}
            aria-label="History meeting"
          />
        </div>
      ),
    },
  ];

  const handleStatusChipClick = (statusValue) => {
    const statusOption = SchedulerStatus.find((list) => list.value === statusValue);
    const isActive = filters?.status?.value === statusValue;
    handleApplyFilters({
      ...filters,
      status: isActive ? null : statusOption,
    });
  };

  // Helper function to get display label for filters
  const getFilterLabel = (key, value) => {
    if (key === "meetingPerson" || key === "assistant" || key === "status" || key === "initialInfoMedium" || key === "finalInfoMedium") {
      return value?.label || value;
    }
    if (key === "startDate" || key === "endDate") {
      return `${key === "startDate" ? "Start" : "End"}: ${value}`;
    }
    return value;
  };

  return (
    <div>
      {loader &&(
        <Loading/>
      )}
      <AnimatedContent>
        <div className="flex justify-between items-center mb-5 flex-wrap gap-3">
          <PageTitle title="Meeting Info" />
          <div className="flex items-center gap-2 flex-wrap">
            <button
              onClick={() => handleStatusChipClick("COMPLETED")}
              className={`bg-green-50 border text-green-700 rounded-[10px] px-4 py-2 text-sm font-semibold flex items-center gap-2 ${
                filters?.status?.value === "COMPLETED" ? "border-green-600 ring-2 ring-green-500" : "border-green-400"
              }`}
            >
              <span>Completed: {statusCounts?.completed ?? 0}</span>
              {filters?.status?.value === "COMPLETED" && <MdOutlineCancel className="text-base" />}
            </button>
            <button
              onClick={() => handleStatusChipClick("NOT_YET_STARTED")}
              className={`bg-yellow-50 border text-yellow-700 rounded-[10px] px-4 py-2 text-sm font-semibold flex items-center gap-2 ${
                filters?.status?.value === "NOT_YET_STARTED" ? "border-yellow-600 ring-2 ring-yellow-500" : "border-yellow-400"
              }`}
            >
              <span>Not Yet Started: {statusCounts?.notYetStarted ?? 0}</span>
              {filters?.status?.value === "NOT_YET_STARTED" && <MdOutlineCancel className="text-base" />}
            </button>
            <button
              onClick={() => handleStatusChipClick("CANCELLED")}
              className={`bg-red-50 border text-red-700 rounded-[10px] px-4 py-2 text-sm font-semibold flex items-center gap-2 ${
                filters?.status?.value === "CANCELLED" ? "border-red-600 ring-2 ring-red-500" : "border-red-400"
              }`}
            >
              <span>Cancelled: {statusCounts?.cancelled ?? 0}</span>
              {filters?.status?.value === "CANCELLED" && <MdOutlineCancel className="text-base" />}
            </button>
            {Object.entries(filters).map(([key, value]) =>
              value && key !== "status" ? (
                <>
                  <CustomChip
                    key={key}
                    label={getFilterLabel(key, value)}
                    onRemove={() => removeFilter(key)}
                  />
                </>
              ) : null
            )}
            {Object.entries(filters).some(([key, val]) => key !== "status" && val) && (
              <button
                onClick={() => {
                  if(!filters.startDate || !filters.endDate) {
                    notifyError("Please select both start and end date");
                    return
                  }else{
                    handleReportDownload()
                  }
                }}
                className={`${
                  loading
                    ? "bg-slate-200  w-[131px] h-[50px] flex items-center justify-center gap-6 rounded-[10px]"
                    : "bg-primary w-[131px] h-[50px] text-white flex items-center justify-center gap-6 rounded-[10px]"
                }`}
                aria-label="Download"
              >
                <span>Download</span>
              </button>
            )}
            <button
              onClick={() => setModalOpen(true)}
              className="bg-white w-[131px] h-[50px] text-primary flex items-center justify-center gap-6 rounded-[10px]"
              aria-label="Open filter drawer"
            >
              <span>Filter</span>
              <FaFilter className="text-xs" />
            </button>
          </div>
        </div>

        <MeetingTable
          columns={columns}
          data={data}
          loading={loading}
          limit={limit}
          currentPage={currentPage}
          nextId={nextId}
          prevId={prevId}
          handlePageChange={handlePageChange}
          handlePageSize={handlePageSize}
          hasMore ={hasMore}
        />
      </AnimatedContent>

      <Drawer
        open={modalOpen}
        title="Filters"
        onClose={() => setModalOpen(false)}
      >
        <MeetingFilter
          presonList={presonList}
          meetingPersonData={meetingPersonData}
          onApplyFilters={handleApplyFilters}
          filters={filters}
          onClearFilters={handleClearFilters}
        />
      </Drawer>

      <Drawer
        open={visible}
        title="Meeting Info"
        onClose={() => setVisible(false)}
      >
        <MeetingInfoTabs
          meeting={selectedMeeting}
          setVisible={setVisible}
          setVisibleHistory={setVisibleHistory}
        />
      </Drawer>

      <Drawer
        open={visibleHistory}
        isBack={true}
        title="History Info"
        onClose={() => {
          setVisibleHistory(false);
        }}
      >
        <MeetingHistory meeting={selectedMeeting} meetingId={meetingId} />
      </Drawer>

      <ListModel
        open={isListModelOpen}
        selectedId={selectedId}
        meetingId={selectedMeeting?.id}
        setSelectedId={setSelectedId}
        onSubmit={handleReassign}
        data={presonList}
        onClose={() => setIsListModelOpen(false)}
      />
    </div>
  );
};

export default Dashboard;
